import React, { useState, memo } from 'react';
import css from './Sections.module.css';
import { Icons } from '../../../components';
import noAvatar from '../../../assets/no-image.jpg';
import moment from 'moment';
import { MAX_STARS } from '../../../util/constants';

const ReviewItem = memo(({ review, intl }) => {
  const avatarUrl =
    review?.author?.profileImage?.attributes?.variants?.['square-small']?.url || noAvatar;
  const displayName = review?.author?.attributes?.profile?.displayName;
  const createdAt = new Date(review?.attributes?.createdAt);
  const rating = review?.attributes?.rating;
  const content = review?.attributes?.content;

  const timeAgo = createdAt => {
    return moment(createdAt).fromNow();
  };

  return (
    <div className={css.reviewItem}>
      <div className={css.reviewsAvatar}>
        <img
          src={avatarUrl}
          alt={intl.formatMessage({ id: 'ProfilePage.Reviews.avatarAlt' }, { displayName })}
          loading="lazy"
        />
      </div>
      <div className={css.reviewContent}>
        <div className={css.reviewHeader}>
          <span className={css.authorName}>{displayName}</span>
          <span className={css.reviewTime}>{timeAgo(createdAt)}</span>
        </div>
        <div className={css.stars}>
          {Array.from({ length: MAX_STARS }, (_, i) => (
            <Icons
              key={i}
              name={i < rating ? 'starFilled' : 'starOutline'}
              className={i < rating ? css.starIcon : css.emptyStarIcon}
              aria-hidden="true"
            />
          ))}
        </div>
        <p className={css.reviewText}>{content}</p>
      </div>
    </div>
  );
});

const Reviews = ({ reviews, intl }) => {
  const [showAll, setShowAll] = useState(false);
  const displayedReviews = showAll ? reviews : reviews.slice(0, 2);

  if (reviews.length === 0) {
    return (
      <div className={css.reviewsContainer}>
        <p className={css.noResultFound}>
          {intl.formatMessage({ id: 'ProfilePage.Reviews.noReviews' })}
        </p>
      </div>
    );
  }

  return (
    <div className={css.reviewsContainer}>
      {displayedReviews?.map(review => (
        <ReviewItem key={review?.id?.uuid} review={review} intl={intl} />
      ))}
      {reviews.length > 2 && !showAll && (
        <span type="button" className={css.reviewsViewAll} onClick={() => setShowAll(true)}>
          {intl.formatMessage({ id: 'ProfilePage.Reviews.viewAllReviews' })}
        </span>
      )}{' '}
    </div>
  );
};

export default Reviews;
